exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-67ab27ab]{padding:20px}.logo[data-v-67ab27ab]{display:block;margin:30px auto}.at-char[data-v-67ab27ab]{color:#4e7eef}.single-large[data-v-67ab27ab]{display:block;margin:30px auto;padding:.5rem 1.5rem}", ""]);

// exports
